export default __webpack_public_path__ + "alberta-fab-edit.72694abe1b2a9d29d9f6.svg";